import { render, staticRenderFns } from "./ConsultRecords.vue?vue&type=template&id=482df691&"
import script from "./ConsultRecords.vue?vue&type=script&lang=js&"
export * from "./ConsultRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports